import { flex, flexColumn } from 'hfty-styles/src/mixins'

const CONTENT_MAX_WIDTH = '1600px'
const CARDS_LIST_WIDTH = '73%'
const FORM_WIDTH = '27%'
const FORM_MIN_WIDTH = '395px'

export const styles = {
  orderSuppliesLayout: {
    ...flex('center', 'flex-start'),
    width: '100%',
  },
  layoutContent: {
    ...flexColumn(),
    width: '100%',
    maxWidth: CONTENT_MAX_WIDTH,
    padding: '50px',
  },
  layoutHeader: {
    width: '100%',
  },
  mainWrapper: {
    width: '100%',
    fontSize: '1em',
    color: 'rgb(121, 121, 121)',
    lineHeight: '23px',
  },
  main: {
    display: 'flex',
    width: '100%',
  },
  cardsList: {
    ...flexColumn('flex-start', 'flex-start'),
    width: CARDS_LIST_WIDTH,
  },
  cardsWrapper: {
    width: '100%',
  },
  form: {
    ...flex('flex-end', 'flex-start'),
    width: FORM_WIDTH,
    minWidth: FORM_MIN_WIDTH,
  },
  errorsContainer: {
    ...flex('flex-end'),
    width: '100%',
    marginTop: 25,
  },
  errorMessage: {
    ...flexColumn('flex-start', 'flex-start'),
    color: 'red',
  },
  layoutFooter: {
    width: '100%',
  },
}
